import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Dialog } from '@app/shared/dialog/dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LinkService } from '@app/core/link.service';
import { DateRange, Timestamp } from '@app/core/models/firebase.model';

@Component({
  selector: 'datetime-range-picker-dialog',
  templateUrl: './datetime-range-picker-dialog.component.html',
  styleUrls: ['./datetime-range-picker-dialog.component.scss'],
})
export class DatetimeRangePickerDialogComponent extends Dialog {
  form!: FormGroup;

  @Input()
  minDate: Timestamp;

  @Input()
  maxDate: Timestamp;

  @Input()
  title: string;

  private callback: (dateRange: DateRange) => void;

  constructor(protected location: Location, protected linkSerivce: LinkService, private formBuilder: FormBuilder) {
    super(location, linkSerivce, 'date-range-picker-dialog', false);
    this.createForm();
  }

  edit(dateRange: DateRange, defaultValue: DateRange, callback: (dateRange: DateRange) => void) {
    this.callback = callback;
    this.form.setValue({
      dateRange: dateRange || defaultValue,
    });

    super.open();
  }

  cancel() {
    this.callback(null);
    this.close();
  }
  close() {
    super.close();
    this.form.reset();
  }

  save() {
    this.callback(this.dateRange.value);
    this.close();
  }

  get dateRange() {
    return this.form.controls.dateRange;
  }

  private createForm() {
    this.form = this.formBuilder.group({
      dateRange: [null, Validators.required],
    });
  }
}
